import type { JpAddressValue } from '../../components/JpAddressInput';
import type { HeadRelationship } from './employeeSectionTypes';

export function formatLegalName(family: string, first: string, middle: string): string {
  const parts = [family.trim(), first.trim(), middle.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : '—';
}

export function formatKanaName(family: string, first: string, middle: string): string {
  const parts = [family.trim(), first.trim(), middle.trim()].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : '—';
}

export function formatDobDisplay(iso: string): string {
  const m = iso.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return iso.trim() || '—';
  return `${m[1]}/${m[2]}/${m[3]}`;
}

export function formatAddressDisplay(a: JpAddressValue): string {
  const lines: string[] = [];
  const zip = a.postalCode.trim();
  if (zip) lines.push(`〒${zip}`);
  const main = [a.pref.trim(), a.city.trim(), a.town.trim()].filter(Boolean).join('');
  if (main) lines.push(main);
  if (a.line2.trim()) lines.push(a.line2.trim());
  return lines.length > 0 ? lines.join('\n') : '—';
}

export function formatYesNo(t: (k: string) => string, v: string): string {
  const s = v.trim().toLowerCase();
  if (s === 'yes' || s === 'true') return t('submitDocuments.dependentDeduction.employee.yes');
  if (s === 'no' || s === 'false') return t('submitDocuments.dependentDeduction.employee.no');
  return v.trim() || '—';
}

export function headRelationshipLabel(t: (k: string) => string, rel: HeadRelationship | ''): string {
  if (!rel) return '—';
  return t(`submitDocuments.dependentDeduction.employee.headRelationship.${rel}`);
}
